import type { ReactNode } from 'react'
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableHeader,
    TableRow,
} from '~/components/ui/table'

// 밀도 높은 데이터 테이블. shadcn 스타일 Table 프리미티브 위에 얇게 감싼 래퍼이다.
// 정렬·필터·페이지네이션·일괄작업은 추후 확장한다. (DESIGN.md §5.2 DataTable)
interface DataTableProps {
    columns: string[]
    rows: ReactNode[][]
    emptyMessage?: string
}

export function DataTable({
    columns,
    rows,
    emptyMessage = '데이터가 없어요.',
}: DataTableProps) {
    return (
        <Table>
            <TableHeader>
                <TableRow>
                    {columns.map((col) => (
                        <TableHead key={col}>{col}</TableHead>
                    ))}
                </TableRow>
            </TableHeader>
            <TableBody>
                {rows.length === 0 ? (
                    <TableRow>
                        <TableCell
                            colSpan={columns.length}
                            className='text-muted-foreground py-8 text-center'>
                            {emptyMessage}
                        </TableCell>
                    </TableRow>
                ) : (
                    rows.map((row, i) => (
                        <TableRow key={i}>
                            {row.map((cell, j) => (
                                <TableCell key={j}>{cell}</TableCell>
                            ))}
                        </TableRow>
                    ))
                )}
            </TableBody>
        </Table>
    )
}
